export const dummyAPIResponse = {
  popularServicesAndLinks: [
    {
      id: 1,
      title: "Overview and History of the South Carolina State Budget",
      href: "",
    },
    {
      id: 2,
      title: "Employer Contribution Trends",
      href: "",
    },
    {
      id: 3,
      title: "Appropriation Bills and Acts",
      href: "",
    },
    {
      id: 4,
      title: "Overview and History of the South Carolina State Budget",
      href: "",
    },
    {
      id: 5,
      title: "Employer Contribution Trends - June 4, 2019",
      href: "",
    },
    {
      id: 6,
      title: "Executive Budget Office State Agency Budget Plans(Requests)",
      href: "",
    },
    {
      id: 7,
      title: "Overview and History of the South Carolina State Budget",
      href: "",
    },
    {
      id: 8,
      title: "Employer Contribution Trends - June 4, 2019",
      href: "",
    },
    {
      id: 9,
      title: "Executive Budget Office State Agency Budget Plan(Requests)",
      href: "",
    },
  ],
  recentUpdates: [
    {
      id: 1,
      title: "Local Government Finance",
      href: "",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean a leo pulvinar, dignissim ex ac, eleifend est. ",
      datePublished: "Jan 2, 2020",
      status: "Updated",
    },
    {
      id: 2,
      title: "Transportation Netwrok Carrier Maps",
      href: "",
      description: "",
      datePublished: "Jan 2, 2020",
      status: "New",
    },
    {
      id: 3,
      title:
        "BEA Long-Range General Fund Revenue Plan for FY 2019-20 to FY 2022-23",
      href: "",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean a leo pulvinar, dignissim ex ac, eleifend est. ",
      datePublished: "Dec 16, 2019",
      status: "Updated",
    },
    {
      id: 4,
      title: "Budget Development",
      href: "",
      description: "",
      datePublished: "Dec 16, 2019",
      status: "New",
    },
    {
      id: 5,
      title: "November 2019 General Fund Revenue Digest",
      href: "",
      description: "",
      datePublished: "Dec 13, 2019",
      status: "New",
    },
  ],
  calendarOfEvents: [
    {
      id: 1,
      eventDate: "2022-11-22T18:37:45.296Z",
      eventTitle: "Board of Economic Advisors Meeting",
      eventLocation:
        "Room 417, Bowers Conference Room, Rembert Dennis Building",
      eventTime: "1:30pm",
      eventContact: "(803) 734-2265",
      eventStatus: "Updated",
    },
    {
      id: 2,
      eventDate: "2022-11-23T18:37:45.296Z",
      eventTitle: "Board of Economic Advisors Meeting",
      eventLocation:
        "Room 417, Bowers Conference Room, Rembert Dennis Building",
      eventTime: "1:30pm",
      eventContact: "(803) 734-2265",
      eventStatus: "Cancelled",
    },
    {
      id: 3,
      eventDate: "2022-11-25T18:37:45.296Z",
      eventTitle: "Board of Economic Advisors Meeting",
      eventLocation:
        "Room 417, Bowers Conference Room, Rembert Dennis Building",
      eventTime: "1:30pm",
      eventContact: "(803) 734-2265",
      eventStatus: "",
    },
    {
      id: 4,
      eventDate: "2022-11-27T00:00:00.000Z",
      eventTitle: "Board of Economic Advisors Meeting",
      eventLocation:
        "Room 417, Bowers Conference Room, Rembert Dennis Building",
      eventTime: "1:30pm",
      eventContact: "(803) 734-2265",
      eventStatus: "",
    },
  ],
};
